/// <amd-module name="VSSUI/Components/Menu/MoreButton" />
import * as React from "react";
import { IExpandable } from "VSSUI/Expandable";
import * as Resources from "VSSUI/Resources.Widgets";
import { IFocusable } from "VSSUI/Utilities/Focus";
import { MenuButton } from "./MenuButton";
import { IMenuButtonProps } from "./MenuButton.Props";

export class MoreButton extends React.Component<IMenuButtonProps> implements IFocusable<{}>, IExpandable {
    private menuButton = React.createRef<MenuButton>();

    public render(): JSX.Element {
        return (
            <MenuButton
                ariaLabel={Resources.MoreActions}
                hideDropdownIcon
                iconProps={{ iconName: "MoreVertical" }}
                ref={this.menuButton}
                subtle
                tooltipProps={{ text: Resources.MoreActions }}
                {...this.props}
            />
        );
    }

    public expand = () => {
        if (this.menuButton.current) {
            this.menuButton.current.expand();
        }
    };

    public collapse = () => {
        if (this.menuButton.current) {
            this.menuButton.current.collapse();
        }
    };

    public focus() {
        if (this.menuButton.current) {
            this.menuButton.current.focus();
        }
    }
}
